<template>
  <span class="category-filter">
    <v-text-field
      v-model="selected"
      :label="categoryLabel"
      clearable
      :placeholder="placeholder"
    />
  </span>
</template>

<script>

export default {
  name: 'CategoryFilter',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      categoryLabel: this.$t('components.filter.ModalFilters.label.category.title'),
      placeholder: this.$t('components.filter.ModalFilters.label.category.placeholder'),
    };
  },
  computed: {
    selected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }

        this.$emit('input', {
          value: newValue,
        });
      },
    },
  },
};

</script>

<style lang="scss">
  .post-by-id-filter {
    .v-select.v-select--chips .v-select__selections {
      min-height: 32px;
    }
  }
</style>
